import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=51e8f237"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports